exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.intro-content[data-v-7f6f7df8] {\n    font-size: 1.1em;\n}\n.intro-footer[data-v-7f6f7df8] {\n    font-size: 1.2em;\n}\n", ""]);

// exports
